//en.js

import enLocale from 'element-ui/lib/locale/lang/en';
import { companyEN } from '@/locales/langs/modules/company';
const en = {
  message: {
    hello: 'hello, world',
  },
  company: companyEN,
  ...enLocale,
};

export default en;
